import React from "react";
import PropTypes from "prop-types";
import {
    StyledLabelBox,
    StyledBoxFlex,
    StyledBackgroundDiv,
    StyledDivCentering,
    StyledLabel,
} from "./filter-button.styled";
import { translateColor } from "@/helper/colors";

const FilterButton = ({ selected, color, onClickHandler, label }) => {
    return (
        <StyledLabelBox selected={selected} color={translateColor(color)} onClick={() => onClickHandler(label)}>
            <StyledBoxFlex>
                <StyledBackgroundDiv color={translateColor(color)} />
                <StyledDivCentering>
                    <StyledLabel> {label} </StyledLabel>
                </StyledDivCentering>
            </StyledBoxFlex>
        </StyledLabelBox>
    );
};

FilterButton.prototypes = {
    selected: PropTypes.bool,
    color: PropTypes.string,
    onClickHandler: PropTypes.func,
    label: PropTypes.string,
};

export default FilterButton;
